import DeleteIcon from './DeleteIcon';
import { OrcamentoIcon } from './OrcamentoUI';
import { useLiquidFeedback } from './LiquidUI';
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './FichasLevantamentoLista.css';

const FichasLevantamentoLista = ({ obraId }) => {
    const liquidFeedback = useLiquidFeedback();
    const [fichas, setFichas] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [viewingFicha, setViewingFicha] = useState(null);

    useEffect(() => {
        if (!obraId) return;
        fetchFichas();
    }, [obraId]);

    const fetchFichas = async () => {
        setIsLoading(true);
        try {
            const res = await api.get(`/fichas-levantamento/obra/${obraId}`);
            setFichas(res.data);
        } catch (error) {
            console.error('Erro ao carregar fichas de levantamento:', error);
            setMessage('Erro ao carregar fichas.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (fichaId) => {
        if (!await liquidFeedback.confirm("Deseja mesmo apagar esta ficha?")) return;
        try {
            await api.delete(`/fichas-levantamento/${fichaId}`);
            liquidFeedback.notify('Ficha apagada com sucesso.');
            fetchFichas();
            if (viewingFicha && viewingFicha.id === fichaId) setViewingFicha(null);
        } catch (error) {
            console.error(error);
            liquidFeedback.notify('Erro ao apagar ficha.');
        }
    };

    const renderAnswerRow = (res) => {
        const fields = [];
        if (res.sn) fields.push(<span key="sn" className={res.sn === 'S' ? 'badge-s' : 'badge-n'} style={{ marginRight: '10px' }}>{res.sn}</span>);
        if (res.quant) fields.push(<span key="quant"><strong>Qtd:</strong> {res.quant}</span>);
        if (res.un) fields.push(<span key="un"><strong>Un:</strong> {res.un}</span>);
        if (res.m2) fields.push(<span key="m2"><strong>m²:</strong> {res.m2}</span>);
        if (res.ml) fields.push(<span key="ml"><strong>m/L:</strong> {res.ml}</span>);
        if (res.largura) fields.push(<span key="largura"><strong>Larg:</strong> {res.largura}m</span>);
        if (res.altura) fields.push(<span key="altura"><strong>Alt:</strong> {res.altura}m</span>);
        if (res.val) fields.push(<span key="val"><strong>Valor:</strong> {res.val}</span>);
        if (res.dropdown) fields.push(<span key="dropdown" style={{ color: '#2b6cb0' }}><strong>Opção:</strong> {res.dropdown}</span>);
        if (res.obs) fields.push(<span key="obs" style={{ color: '#4a5568' }}><em>{res.obs}</em></span>);

        return <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'center' }}>
            {fields.map((f, i) => <React.Fragment key={i}>{f}</React.Fragment>)}
        </div>;
    };

    const renderFichaDetalhe = (ficha) => {
        const sections = ficha.template_sections || [];
        const dados = ficha.dados || {};

        return (
            <div className="ficha-detalhe-view">
                <h3>Respostas - {ficha.template_nome}</h3>
                <p><strong>Preenchido em:</strong> {new Date(ficha.criado_em).toLocaleString('pt-PT')} por {ficha.preenchido_por_nome || 'Desconhecido'}</p>

                <div className="ficha-respostas">
                    {sections.map((sec, sIdx) => (
                        <div key={sIdx} className="ficha-respostas-sec">
                            <h4>{sec.title}</h4>
                            <table className="ficha-res-table">
                                <tbody>
                                    {sec.questions?.map(q => {
                                        const res = dados[q.id] || {};
                                        return (
                                            <tr key={q.id}>
                                                <td width="30%">
                                                    <strong>{q.label}</strong>
                                                </td>
                                                <td width="70%">
                                                    {res.rows && res.rows.length > 0 ? (
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                            {res.rows.map((r, rIdx) => (
                                                                <div data-liquid-surface="true" key={rIdx} style={{ padding: '8px', background: 'white', border: '1px solid #e2e8f0', borderLeft: '3px solid #4299e1', borderRadius: '4px', fontSize: '13px' }}>
                                                                    <div style={{ fontWeight: 'bold', color: '#2b6cb0', marginBottom: '6px' }}>#{rIdx + 1}</div>
                                                                    {renderAnswerRow(r)}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        renderAnswerRow(res)
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ))}
                </div>

                {ficha.fotos && ficha.fotos.length > 0 && (
                    <div className="ficha-fotos">
                        <h4>Fotos Anexadas</h4>
                        <div className="ficha-fotos-grid">
                            {ficha.fotos.map((src, idx) => (
                                <img key={idx} src={src} alt={`Foto ${idx}`} onClick={() => window.open(src, '_blank')} />
                            ))}
                        </div>
                    </div>
                )}

                <button className="btn-secondary" onClick={() => setViewingFicha(null)} style={{ marginTop: '20px' }}>Fechar Visualização</button>
            </div>
        )
    };

    return (
        <div className="info-card" style={{ marginTop: '20px' }}>
            <h2><OrcamentoIcon name="document" fallback="📋" /> Fichas de Levantamento</h2>

            {message && <div style={{ color: 'red', marginBottom: '10px' }}>{message}</div>}

            {!viewingFicha ? (
                isLoading ? (
                    <p>A carregar...</p>
                ) : (
                    <div className="fichas-list">
                        {fichas.length === 0 ? (
                            <p style={{ color: '#666', fontStyle: 'italic' }}>Nenhuma ficha preenchida para esta obra.</p>
                        ) : (
                            <table className="fichas-table">
                                <thead>
                                    <tr>
                                        <th>Template</th>
                                        <th>Data</th>
                                        <th>Preenchido Por</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fichas.map(f => (
                                        <tr key={f.id}>
                                            <td>{f.template_nome}</td>
                                            <td>{new Date(f.criado_em).toLocaleDateString('pt-PT')}</td>
                                            <td>{f.preenchido_por_nome || '-'}</td>
                                            <td>
                                                <button className="btn-secondary" style={{ padding: '5px 10px', marginRight: '5px' }} onClick={() => setViewingFicha(f)}><OrcamentoIcon name="eye" fallback="👁️" /> Ver</button>
                                                <button className="btn-danger" style={{ padding: '5px 10px' }} onClick={() => handleDelete(f.id)}><DeleteIcon /> Apagar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                )
            ) : (
                renderFichaDetalhe(viewingFicha)
            )}
        </div>
    );
};

export default FichasLevantamentoLista;
